import searchAddresses from 'api/scheduler/searchAddresses';

/**
 * Fetch all locations (addresses) from the API
 * Transforms API response to match expected format: { id, name, companyId }
 * @returns {Promise<Array>} Promise that resolves to an array of location objects
 */
export const fetchLocations = async () => {
  const { data } = await searchAddresses(null, '', 1, 500);

  // Transform API response to match expected format
  // API returns { Id, Title, CustomerId } for each address
  return data.map((address) => ({
    id: address.Id,
    name: address.Title,
    companyId: address.CustomerId,
    // Preserve original fields for reference
    originalData: address,
  }));
};

/**
 * Fetch locations for a specific company
 * @param {number|string} companyId - The ID of the company
 * @returns {Promise<Array>} Promise that resolves to filtered location array
 */
export const fetchLocationsByCompany = async (companyId) => {
  if (!companyId) {
    return [];
  }

  const { data } = await searchAddresses(companyId, '', 1, 500);

  // Transform API response to match expected format
  // API returns { Id, Title, CustomerId } for each address
  return data.map((address) => ({
    id: address.Id,
    name: address.Title,
    companyId: address.CustomerId,
    // Preserve original fields for reference
    originalData: address,
  }));
};

/**
 * Fetch a location by ID
 * @param {number|string} locationId - The ID of the location
 * @returns {Promise<Object|null>} Promise that resolves to a location object or null
 */
export const fetchLocationById = async (locationId) => {
  const locations = await fetchLocations();
  return locations.find((l) => l.id === locationId || l.id === String(locationId)) || null;
};
